function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#bcaaa4",
  d: "M41.4,21.8L24,8.3L6.6,21.8l-1.2-1.6l18-14c0.4-0.3,0.9-0.3,1.2,0l18,14L41.4,21.8z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#dd2c00",
  d: "M3,20h42v22H3V20z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff5722",
  d: "M5,22h38v18H5V22z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15 34.3h2V36h-4V26h2V34.3zM28.1 33.3c0-.4-.1-.7-.3-.9s-.5-.4-1-.6c-.9-.4-1.6-.8-2-1.3-.4-.5-.6-1.1-.6-1.8 0-.8.3-1.5.8-2 .5-.5 1.2-.7 2.1-.7.6 0 1.1.1 1.5.4.4.3.8.6 1 1.1.2.5.4 1 .4 1.6l-2 0c0-.5-.1-.8-.3-1-.2-.2-.3-.3-.6-.3-.3 0-.6.1-.8.3s-.3.5-.3.8c0 .3.1.5.3.7.2.2.6.4 1.1.7.9.3 1.5.8 1.9 1.3.4.5.6 1.1.6 1.9 0 .8-.3 1.5-.8 2C28.7 35.8 28 36 27.2 36c-.6 0-1.1-.1-1.6-.4s-.9-.6-1.1-1.1C24.1 34 24 33.5 24 32.8h1.9c0 .6.1 1 .3 1.2s.5.4 1 .4C27.8 34.4 28.1 34 28.1 33.3zM22.2 27.1C21.7 26.4 20.9 26 20 26c-.9 0-1.7.4-2.2 1.1-.5.8-.8 1.8-.8 3.1v1.7c0 1.3.3 2.3.8 3 .5.7 1.3 1.1 2.2 1.1.9 0 1.7-.4 2.2-1.1s.8-1.7.8-3v-1.7C23 28.9 22.7 27.8 22.2 27.1zM21 31.9c0 .8-.1 1.4-.2 1.8s-.4.6-.7.6c-.3 0-.6-.2-.8-.6-.2-.4-.2-1-.2-1.9v-1.7c0-.8.1-1.5.3-1.9.2-.4.4-.6.8-.6s.6.2.8.6c.2.4.2 1.1.2 2V31.9zM35 31.7h-2v2.6h2V36h-4V26h4v1.7h-2V30h2V31.7z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#37474f",
  d: "M26,8c0,1.1-0.9,2-2,2s-2-0.9-2-2s0.9-2,2-2S26,6.9,26,8z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M36 36V26h2.2c1.2 0 2.1.4 2.8 1.2.7.7 1 1.8 1.1 3v1.6c0 1.3-.3 2.3-1 3.1S39.3 36 38.1 36H36zM38 27.7v6.6h.1c.7 0 1.1-.2 1.4-.5.3-.4.4-1 .4-1.8v-1.7c0-.9-.1-1.6-.4-1.9-.3-.4-.7-.6-1.3-.6H38zM10 32.5c0 .5-.1 1-.2 1.3-.2.4-.4.6-.7.6-.3 0-.6-.2-.8-.6-.2-.4-.2-1-.2-1.9v-1.7c0-.8.1-1.5.3-1.9.2-.4.4-.6.8-.6s.6.2.8.6c.1.3.2.7.2 1.3h2c-.1-1-.3-1.8-.8-2.4C10.7 26.4 9.9 26 9 26c-.9 0-1.7.4-2.2 1.1C6.3 27.9 6 28.9 6 30.3v1.7c0 1.3.3 2.3.8 3C7.3 35.6 8.1 36 9 36c.9 0 1.7-.4 2.2-1.1.4-.6.7-1.4.8-2.4H10z"
});

const SvgClosed = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClosed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/closed.a3b0e808.svg";
export { ForwardRef as ReactComponent };